<template>
  <div id="app" class=" h-full">
    <div class=" sm:hidden h-full flex-col">
      <navbar class="" :isLoggedIn=IsLoggedIn></navbar>
      <router-view/>
    </div>
    <div class=" hidden sm:flex justify-center h-screen">
      <div class=" my-auto text-3xl px-10 ">
        Sorry, This App can only run on phones
      </div>

    </div>

  </div>
  
</template>

<script>
// @ is an alias to /src
// import Footer from '@/components/core/partials/_footer.vue'
// import Btm_navbar from '@/components/core/partials/btm_navbar.vue'
import navbar from '@/components/core/partials/navBar.vue'
// import router from './router';

export default {
  name: 'HomeView',
  components: {
    // Footer,
    // Btm_navbar,
    navbar
    
  },
  data(){
            return {
                username: '',
                IsLoggedIn:false,
                OpenBank:{
                  mom:'',
                  dad:'',
                  ed:'',
                  createdBy:''
                },
                Banks:[],
                SelectedBank:{},
                activeChat:[],
                returtToUrl:''
                  
                // userData: null,
                // loginStatus: null
            }
        },
        methods:{
          logout(){
            this.IsLoggedIn = false;
          },
          login(username){
            this.IsLoggedIn = true;
            this.username = username;
            localStorage.setItem('account', JSON.stringify({
            username:username
        }))
          },
          scrollToElement() {
            const el = document.getElementById("app");
            //  console.log("Top")
            if (el) {
              // Use el.scrollIntoView() to instantly scroll to the element
              el.scrollIntoView({ behavior: "instant", block: "end" });
             
            }
          },
          UpdateMomDad(mom,dad){
            this.OpenBank.mom = mom;
            this.OpenBank.dad = dad;
          },    
          UpdateED(date){
            this.OpenBank.ed = date;
          },    
          UpdateCreatedBy(){
            this.OpenBank.createdBy = this.username;
          },
          
          AddBank(mom,dad,ed,createdBy){
            let banks = JSON.parse(localStorage.getItem('banks'));
            if(banks == null){
                banks = {}
              }
            if(Object.hasOwn(banks,createdBy)){
              alert('Bank already joined')
            }else{
              
              banks = {...banks, [createdBy] : {
                                   mom: mom,
                                   dad: dad,
                                   ed: ed,
                                   votes: {admin:"Boy Or Girl"},
                                   donations:[{
                                    username:createdBy,
                                    amount:0
                                   }],
                                   result:'',                                   
                                   chat:[{
                                    username: createdBy,
                                    time: Date(Date.now()),
                                    message: "Welcome "+this.username+" to "+mom+" and "+dad+"'s Baby Bank",
                                    status: "Delivered"
                                   }],
                                   createdBy:createdBy
                               } }
             
              localStorage.setItem('banks', JSON.stringify(
                            banks
                        ))
              const redirectPath = this.$route.query.redirect || '/OpenBanks'
              this.$router.push(redirectPath)
            }
            
            
          },
          UpdateChat(chat){
            
            this.Banks[this.SelectedBank.createdBy].chat = chat
            localStorage.setItem('banks', JSON.stringify(
                            this.Banks
                        ))

          },
          UpdateDonation(donations){
            
            this.Banks[this.SelectedBank.createdBy].donations = donations
            localStorage.setItem('banks', JSON.stringify(
                            this.Banks
                        ))
          },
          UpdateVotes(votes){
            this.Banks[this.SelectedBank.createdBy].votes = votes
  
            localStorage.setItem('banks', JSON.stringify(
                            this.Banks
                        ))
          },
          UpdateAdminED(ed){
            this.Banks[this.SelectedBank.createdBy].ed = ed

            localStorage.setItem('banks', JSON.stringify(
                            this.Banks
                        ))
          },
          UpdateResults(result){
            this.Banks[this.SelectedBank.createdBy].result = result
            localStorage.setItem('banks', JSON.stringify(
                            this.Banks
                        ))
          }

        },
        created(){
          // console.log(window.location.origin)
          let user = JSON.parse(localStorage.getItem('account'));
          let allUsers = localStorage.getItem('users');

          if(user) {
            // this.selectedUser = user;
            this.IsLoggedIn = true;
            this.username = user.username;
            // console.log(user.username)
            const redirectPath = this.$route.query.redirect || '/OpenBanks'
            this.$router.push(redirectPath)
            // alert("user is logged in")
          }
          if(!allUsers){
            localStorage.setItem('users', JSON.stringify({}))
          }
        }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  /* color: #2c3e50; */
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  /* color: #2c3e50; */
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
